import React from "react";
import PropTypes from "prop-types";
import { Tag, Affix } from "antd";
import { NotificationFilled } from "@ant-design/icons";

const styles = {
  bar: {
    width: "100%",
    padding: 5,
    backgroundColor: "#1890ff",
    textAlign: "center",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)"
  },
  link: {
    color: "#fff"
  },
  linkText: {
    fontWeight: 700
  }
};

const AnnoucementBar = props => (
  <Affix offsetTop={0}>
    <div id="announcement-bar" style={styles.bar}>
      <Tag color="#2db7f5">
        <NotificationFilled />
      </Tag>
      <a target="_new" href={props.link} onClick={props.onClick} style={styles.link} id="announcement-bar-link">
        <span id="announcement-bar-link-text" style={styles.linkText}>
          {props.text}
        </span>
      </a>
    </div>
  </Affix>
);
AnnoucementBar.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};

export default AnnoucementBar;
